import { CATEGORY_CONTENT_MAP } from '../index';
import { Category } from '../WaysToTour';

export const categorySort = (arr: Category[] | undefined) => {
    if (arr && arr.length > 0) {
        arr.sort((a, b) => {
            const tagA = CATEGORY_CONTENT_MAP[a.tag || ''].title.toString();
            const tagB = CATEGORY_CONTENT_MAP[b.tag || ''].title.toString();
            if (tagA > tagB) {
                return 1;
            } else if (tagA < tagB) {
                return -1;
            }
            return 0;
        });
    }
    return 0;
};
